import { Box, Card, CardContent, Typography, Link } from "@mui/material";
import {
  GroupedSuppliesTableRow,
  GroupedSuppliesTableRowKeys,
  SuppliesDataCard,
  SuppliesDataCardContentVariant,
} from "../../../core/models/supplies/supplies.model";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { setSupplySelectedToLocalStorage } from "../../../core/services/localStorage/localStorage.service";

interface SuppliesCardProps {
  suppliesTableRows: GroupedSuppliesTableRow[];
  isAdministrator: boolean | undefined;
}

const SuppliesCard = ({
  suppliesTableRows,
  isAdministrator,
}: SuppliesCardProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const suppliesDataCard: SuppliesDataCard[] = [
    ...(isAdministrator
      ? [
          {
            id: "socialReason" as GroupedSuppliesTableRowKeys,
            title: "Razón social",
            fontWeight: "700",
            contentVariant: "subtitle1",
          },
          {
            id: "cif" as GroupedSuppliesTableRowKeys,
            title: "CIF",
          },
        ]
      : []),
    {
      id: "suppliesDirection" as GroupedSuppliesTableRowKeys,
      title: "Dirección de suministro",
      ...(!isAdministrator && {
        fontWeight: "700",
        contentVariant: "subtitle1",
      }),
    },
    {
      id: "town" as GroupedSuppliesTableRowKeys,
      title: "Localidad",
    },
    {
      id: "rate" as GroupedSuppliesTableRowKeys,
      title: "Tarifa",
    },
    {
      id: "billsNumber" as GroupedSuppliesTableRowKeys,
      title: "Facturas",
      cellContent: (row: GroupedSuppliesTableRow) => (
        <Link
          className="link-button-card  bills-button-card"
          component="button"
          onClick={() => {
            setSupplySelectedToLocalStorage(row);
            navigate(
              `${process.env.REACT_APP_BILLS}/${row.cupsId}?origin=supplies`
            );
          }}
          fontWeight={700}
          underline="always"
        >{`${row.billsNumber} Facturas`}</Link>
      ),
    },
    {
      id: "CUPS" as GroupedSuppliesTableRowKeys,
      title: "CUPS",
      cellContent: (row: GroupedSuppliesTableRow) => (
        <Link
          className="link-button-card"
          component="button"
          onClick={() => {
            setSupplySelectedToLocalStorage(row);
            navigate(
              `${process.env.REACT_APP_SUPPLIES}/${row.cupsId}?origin=supplies`
            );
          }}
          fontWeight={700}
          underline="always"
        >
          {row.CUPS}
        </Link>
      ),
    },
  ];

  return (
    <Box component="article" sx={{ marginBottom: 5 }}>
      {suppliesTableRows.map((row, indexNumber) => (
        <Card key={`${row.id}_${indexNumber}`} sx={{ marginBottom: 2 }}>
          <CardContent
            sx={{
              padding: "1 rem",
              paddingBottom: 0,
              display: "flex",
              columnGap: "1rem",
              flexDirection: "column",
            }}
          >
            {suppliesDataCard.map(
              ({ id, title, contentVariant, fontWeight, cellContent }) => {
                const textContent = row[id as GroupedSuppliesTableRowKeys];
                return (
                  <Box key={id}>
                    {!!title.length && (
                      <Typography
                        variant="caption"
                        component="h4"
                        sx={{ color: "grey.700", marginBottom: "0.25rem" }}
                      >
                        {t(`Tablas.${title}`)}
                      </Typography>
                    )}
                    {cellContent ? (
                      cellContent(row)
                    ) : (
                      <Typography
                        gutterBottom
                        variant={
                          (contentVariant as SuppliesDataCardContentVariant) ||
                          "body1"
                        }
                        component="p"
                        fontWeight={fontWeight || 400}
                        marginBottom="1rem"
                      >
                        {textContent as string}
                      </Typography>
                    )}
                  </Box>
                );
              }
            )}
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default SuppliesCard;
